// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"27":"21f2385eb1783437","52":"dbe5fdd2a03da3d2","199":"c6b96e2e6380aee4","320":"a4a1e840a4003ae2","372":"d97db56d731506fc","454":"b4ab45076717e7b7","554":"0daec4470cc8e8d1","583":"d18bce69189090b1","586":"584b0249275bd66a","806":"b0eee27588a2106f"}[chunkId] + ".js";
};